/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const putPipeSeriesPipeseriesidPathPipeSeriesIdSchema = z.string()

export const putPipeSeriesPipeseriesidStatus200Schema = z.object({
  name: z.string().describe('The name of the pipe series').meta({ examples: ['Custom Pipe Series 1'] }),
  id: z.string().describe('Unique identifier').meta({ examples: [1] }),
  pipes: z.array(z.object({
    internalDiameter: z.number().describe('The internal diameter of the pipe in millimeters').meta({ examples: [100] }),
    maxPressure: z.number().describe('The maximum pressure the pipe can withstand in bar').meta({ examples: [10] }),
    maxTemperature: z.number().describe('The maximum temperature the pipe can withstand in Celsius').meta({ examples: [120] }),
    name: z.string().describe('The name of the pipe').meta({ examples: ['Pipe 1'] }),
    roughness: z.number().describe('The roughness of the pipe in micrometers').meta({ examples: [50] }),
    valveSize: z.string().describe('The size of the valve associated with the pipe').meta({ examples: ['DN_10'] }),
    id: z.string().describe('Unique identifier').meta({ examples: [1] }),
  })).min(1).describe('The list of pipes in the series, at least one pipe is required'),
})

export const putPipeSeriesPipeseriesidStatus400Schema = z.string()

export const putPipeSeriesPipeseriesidStatus401Schema = z.string()

export const putPipeSeriesPipeseriesidStatus404Schema = z.string()

export const putPipeSeriesPipeseriesidStatus500Schema = z.string()

export const putPipeSeriesPipeseriesidResponseSchema = putPipeSeriesPipeseriesidStatus200Schema

export const putPipeSeriesPipeseriesidErrorSchema = z.union([putPipeSeriesPipeseriesidStatus400Schema, putPipeSeriesPipeseriesidStatus401Schema, putPipeSeriesPipeseriesidStatus404Schema, putPipeSeriesPipeseriesidStatus500Schema])

export const putPipeSeriesPipeseriesidBodySchema = z.object({
  name: z.string().describe('The name of the pipe series').meta({ examples: ['Custom Pipe Series 1'] }),
  pipes: z.array(z.object({
    internalDiameter: z.number().describe('The internal diameter of the pipe in millimeters').meta({ examples: [100] }),
    maxPressure: z.number().describe('The maximum pressure the pipe can withstand in bar').meta({ examples: [10] }),
    maxTemperature: z.number().describe('The maximum temperature the pipe can withstand in Celsius').meta({ examples: [120] }),
    name: z.string().describe('The name of the pipe').meta({ examples: ['Pipe 1'] }),
    roughness: z.number().describe('The roughness of the pipe in micrometers').meta({ examples: [50] }),
    valveSize: z.string().describe('The size of the valve associated with the pipe').meta({ examples: ['DN_10'] }),
  })).min(1).describe('The list of pipes in the series, at least one pipe is required'),
}).optional()
